import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-8 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-play-circle-fill text-background-50 text-xl"></i>
                </div>
                <span className="font-heading text-lg font-bold text-background-50">传媒在线观看</span>
              </div>
              <p className="text-sm text-foreground-300 leading-relaxed">
                汇聚海量高清视频资源，支持直播、点播、回看全场景体验。无需下载，打开即看。
              </p>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">内容分类</h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">快速链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">首页</Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link>
                </li>
                <li>
                  <a href="#faq" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">联系我们</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-foreground-300">
                  <i className="ri-mail-line text-primary-400"></i>
                  <span>contact@chuanmeizaixian.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-300">
                  <i className="ri-phone-line text-primary-400"></i>
                  <span>400-888-0000</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-300">
                  <i className="ri-map-pin-line text-primary-400"></i>
                  <span>北京市朝阳区传媒大厦</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-foreground-400">
              &copy; 2026 传媒在线观看 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="哔哩哔哩">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}